export default __webpack_public_path__ + "locales/lo-LA/ChangeUserStatusDialog.json?hash=a8ee16b8526aa37036abb43eaba13478";